"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceFloat = void 0;
exports.sliceFloat = function (string) {
    var match = string.match(/[+-]?\d+(\.\d+)?/g);
    if (match) {
        return parseFloat(match[0]);
    }
    else {
        return 0;
    }
};
